<div class="terms-conditions-note">
  <p class="terms-conditions-note__caption">{{ 'uigLegal.termsCaption' | cxTranslate }}</p>
  <span class="terms-conditions-note__detail-caption">{{ 'uigLegal.termsText1' | cxTranslate }}</span>
  <a (click)="openTermsAndConditions()"
     class="cx-tc-link terms-conditions-note__detail-caption"
     target="_blank">
    {{ 'uigLegal.termsAGB' | cxTranslate }}
  </a>
  <span class="terms-conditions-note__detail-caption">{{ 'uigLegal.termsText2' | cxTranslate }}</span>
</div>